// extracted by mini-css-extract-plugin
module.exports = {"models":"Machine_models__D2eCH"};